var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graphic",style:(_vm.stickyStyle),attrs:{"offset":_vm.offset,"step":_vm.step}},[_vm._t("sticky")],2)}
var staticRenderFns = []

export { render, staticRenderFns }